import React, { Component } from 'react'
import { Modal } from 'antd'
import { injectIntl } from 'react-intl'
import { withApollo } from '@apollo/client/react/hoc'
import gql from 'graphql-tag'

import { DeviceDetailsQuery, DeviceActionMutation } from './Queries'
import TZ from '../../resources/timezones'
import * as Utils from '../../components/Utils'
import { SelectTimezone } from './SelectTimezone'

class TimeZone extends Component {
	state = {
		error: null,
		zone: this.props.device.timeZone,
		restart: false
	}

	handleCancel = () => {
		this.props.onClose()
	}

	handleTimeChange = async (timezone) => {
		const { device, client, onClose, intl } = this.props
		this.setState({ zone: timezone })
		try {
			const r = await client.mutate({
				variables: {
					device: device._id,
					timeZone: timezone
				},
				mutation: gql`
					mutation updateDeviceTimezone(
						$device: MongoID!
						$timeZone: String!
					) {
						deviceUpdateById(
							_id: $device
							record: { timeZone: $timeZone }
						) {
							recordId
						}
					}
				`,
				refetchQueries: [
					{
						query: DeviceDetailsQuery,
						variables: { id: device._id }
					}
				]
			})
			Utils.parseMutationResponse(r)

			if (Utils.isDeviceOnline(device)) {
				const dr = await client.mutate(
					DeviceActionMutation(device, null, 'options')
				)
				Utils.parseMutationResponse(dr)
				Modal.confirm({
					title: intl.formatMessage({
						id: 'devices.info.actions.setTimeZone'
					}),
					content: intl.formatMessage({
						id: 'devices.info.timeZone.restart'
					}),
					okText: intl.formatMessage({
						id: 'devices.info.timeZone.restart.now'
					}),
					cancelText: intl.formatMessage({
						id: 'devices.info.timeZone.restart.later'
					}),
					onOk: this.restart,
					onCancel: onClose
				})
			} else {
				onClose()
			}
		} catch (e) {
			Utils.displayError(e)
		}
	}

	restart = async () => {
		try {
			const { device, client, onClose } = this.props
			const r = await client.mutate({
				variables: { id: device._id, command: 'restart' },
				mutation: gql`
					mutation sendDeviceCommandRestart(
						$id: String!
						$command: String!
					) {
						sendDeviceCommand(_id: $id, command: $command) {
							success
							message
						}
					}
				`
			})
			Utils.parseMutationResponse(r)
			onClose()
		} catch (e) {
			Utils.displayError(e)
		}
	}

	zoneRegion = (z) => {
		for (let group of TZ) {
			for (let zone of group.zones) {
				if (zone.value === z) {
					return group.group
				}
			}
		}
		return null
	}

	render() {
		const { intl, device } = this.props
		const region = this.zoneRegion(this.state.zone)

		// for DraxOS before v5, we handle only a subset of timezones
		// we need to check the device.OS because it can be ubuntu for dante player
		const isDraxBeforeV5 =
			Utils.isDeviceDrax(device) &&
			device.OS === 'DraxOS' &&
			!Utils.isDeviceOSVersionAbove(device, '5.0.0')

		return (
			<Modal
				visible={true}
				title={intl.formatMessage({
					id: 'devices.info.actions.setTimeZone'
				})}
				onCancel={this.handleCancel}
				footer={[]}
			>
				<SelectTimezone
					draxBeforeV5={isDraxBeforeV5}
					onSelect={(timezone) => this.handleTimeChange(timezone)}
					selectedValue={this.state.zone}
				/>
			</Modal>
		)
	}
}

export default withApollo(injectIntl(TimeZone))
